import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface blogsState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: blogsState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const blogsSlice = createSlice({
  name: ' blogs',
  initialState,
  reducers: {
    setBlogs: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewBlogs: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setBlogs, addNewBlogs, reset } = blogsSlice.actions;
export const getBlogs = (state: RootState) => state.blogs.data;
export const addBlogs = (state: RootState) => state.blogs.data;
export const getBlogsTotalRecord = (state: RootState) => state.blogs.totalRecords;
export default blogsSlice.reducer;
